/* Langsomt Nok CRO 13 - scoped product state. No price, inventory or analytics writes. */
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.lnProductReady === 'true') return;
    var configNode = root.querySelector('[data-ln-product-config]');
    var variantsNode = root.querySelector('[data-ln-product-variants]');
    var mediaNode = root.querySelector('[data-ln-variant-media]');
    var config, variants, variantMedia;
    try {
      config = JSON.parse(configNode.textContent);
      variants = JSON.parse(variantsNode.textContent);
      variantMedia = JSON.parse(mediaNode.textContent);
      if (!Array.isArray(variants)) return;
    } catch (error) { return; }
    root.dataset.lnProductReady = 'true';
    var form = root.querySelector('#ln-product-form');
    var variantInput = root.querySelector('#ln-variant-id');
    var quantityInput = root.querySelector('#ln-qty');
    var add = root.querySelector('#ln-add-btn');
    var sticky = root.querySelector('#ln-sticky');
    var stage = root.querySelector('[data-ln-main-media]');
    var swatches = Array.from(root.querySelectorAll('.ln-pdp__swatch'));
    var thumbs = Array.from(root.querySelectorAll('[data-ln-media-id]'));
    var templates = Array.from(root.querySelectorAll('template[data-ln-media-template]'));
    var current = variants.find(function (v) { return variantInput && String(v.id) === variantInput.value; }) || null;
    var selected = current ? current.options.slice() : [];
    var formatter = new Intl.NumberFormat(config.locale || 'da-DK', { style: 'currency', currency: config.currency || 'DKK' });
    function money(cents) { return formatter.format(Number(cents) / 100); }
    function emit(name, detail) { document.dispatchEvent(new CustomEvent(name, { detail: detail })); }
    function showMedia(id) {
      var source = templates.find(function (t) { return t.dataset.lnMediaTemplate === String(id); });
      if (!stage || !source) return;
      stage.querySelectorAll('video').forEach(function (video) { video.pause(); });
      stage.replaceChildren(source.content.cloneNode(true));
      var zoom = root.querySelector('[data-ln-zoom]');
      if (zoom) { zoom.hidden = source.dataset.lnMediaType !== 'image'; if (source.dataset.lnFullSrc) zoom.href = source.dataset.lnFullSrc; }
      thumbs.forEach(function (thumb) {
        var active = thumb.dataset.lnMediaId === String(id);
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', String(active));
      });
    }
    thumbs.forEach(function (thumb) { thumb.addEventListener('click', function () { showMedia(thumb.dataset.lnMediaId); }); });
    function refreshSticky() {
      if (!sticky) return;
      var target = root.querySelector('.ln-pdp__buy, .ln-pdp__soldctas');
      var usable = config.soldUnika || (current && current.available);
      var smallScreen = window.matchMedia('(max-width: 1023px)').matches;
      var show = !!(usable && smallScreen && target && target.getBoundingClientRect().bottom <= 0);
      sticky.hidden = !show;
      document.body.classList.toggle('ln-has-sticky-buy', show);
    }
    function renderVariant(changeMedia) {
      if (!form || !variantInput || !add) { refreshSticky(); return; }
      var available = !!(current && current.available);
      variantInput.value = current ? String(current.id) : '';
      add.disabled = !available;
      var label = available ? (config.isUnika ? 'Giv værket et hjem' : config.ctaLabel) : 'Ikke tilgængelig lige nu';
      var mainLabel = add.querySelector('[data-add-label]');
      if (mainLabel) mainLabel.textContent = label;
      root.querySelectorAll('[data-sticky-add]').forEach(function (button) { button.disabled = !available; button.textContent = label; });
      root.querySelectorAll('[data-ln-primary-price]').forEach(function (node) { node.textContent = current ? money(current.price) : 'Vælg en variant'; });
      document.querySelectorAll('[data-ln-variant-summary]').forEach(function (node) {
        if (node.dataset.lnVariantSummary === config.handle) node.textContent = current ? money(current.price) + ' · ' + (available ? 'På lager' : 'Ikke tilgængelig lige nu') : 'Vælg en variant';
      });
      if (config.handle === 'start-ritualet-knivlist-grundstenen' && current) {
        var wood = current.options[0] === 'Valnød' ? 'walnut' : 'acacia';
        showMedia('bundle-' + wood);
        var bundlePhoto = stage && stage.querySelector('img');
        var currentChoiceMedia = document.querySelector('.ln-current-choice__media');
        if (bundlePhoto && currentChoiceMedia) currentChoiceMedia.replaceChildren(bundlePhoto.cloneNode(true));
      }
      var reduced = !!(current && config.campaign && current.compare_at_price > current.price);
      root.querySelectorAll('[data-compare]').forEach(function (node) {
        node.hidden = !reduced;
        node.textContent = reduced ? money(current.compare_at_price) : '';
      });
      var badge = root.querySelector('[data-ln-sale-badge]');
      if (badge) {
        badge.hidden = !reduced;
        badge.textContent = reduced ? '-' + Math.round((current.compare_at_price - current.price) * 100 / current.compare_at_price) + '%' : '';
      }
      var stock = root.querySelector('[data-ln-stock]');
      if (stock) stock.textContent = available ? (config.isUnika ? 'Findes i ét eksemplar' : 'På lager') : 'Ikke tilgængelig lige nu';
      swatches.forEach(function (button) {
        var on = selected[Number(button.dataset.optionIndex)] === button.dataset.value;
        button.classList.toggle('is-selected', on);
        button.setAttribute('aria-pressed', String(on));
      });
      if (changeMedia && current && variantMedia[String(current.id)]) showMedia(variantMedia[String(current.id)]);
      refreshSticky();
      emit('ln:variant-change', { productHandle: config.handle, variant: current });
    }
    swatches.forEach(function (button) {
      button.addEventListener('click', function () {
        selected[Number(button.dataset.optionIndex)] = button.dataset.value;
        current = variants.find(function (v) { return v.options.every(function (value, index) { return selected[index] === value; }); }) || null;
        renderVariant(true);
      });
    });
    if (quantityInput && form) {
      quantityInput.setAttribute('aria-label', 'Antal');
      form.querySelectorAll('[data-qty]').forEach(function (button) {
        button.addEventListener('click', function () {
          var value = Number(quantityInput.value);
          if (!Number.isInteger(value) || value < 1) value = 1;
          quantityInput.value = String(Math.max(1, value + Number(button.dataset.qty)));
          quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
          quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    }
    if (form) form.addEventListener('submit', function (event) {
      if (!current || !current.available) { event.preventDefault(); return; }
      if (quantityInput && (!Number.isInteger(Number(quantityInput.value)) || Number(quantityInput.value) < 1)) {
        event.preventDefault(); quantityInput.setCustomValidity('Vælg et helt antal på mindst 1.'); quantityInput.reportValidity();
      }
    });
    if (quantityInput) quantityInput.addEventListener('input', function () { quantityInput.setCustomValidity(''); });
    window.addEventListener('scroll', refreshSticky, { passive: true });
    window.addEventListener('resize', refreshSticky, { passive: true });
    if ('IntersectionObserver' in window) {
      var target = root.querySelector('.ln-pdp__buy, .ln-pdp__soldctas');
      if (target) new IntersectionObserver(refreshSticky).observe(target);
    }
    renderVariant(false);
  }
  function initAll() { document.querySelectorAll('[data-ln-product-controller]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();


